const landingAction = {
  CATEGORY: {
    REQUEST: "categoryListFetchRequest",
    FAILURE: "categoryListFetchFailure",
    SUCCESS: "categoryListFetchSuccess",
  },
}

export default landingAction;